/** @file The identity rotation. */
import type { Quat } from './quat';

/** `[0, 0, 0, 1]`. */
export function quatIdentity(): Quat {
  return [0, 0, 0, 1];
}
